"use client";

import { BuySellSwitch } from "#/components/BuySellSwitch/BuySellSwitch";
import { useMarket } from "#/store/app/portfolio/market";
import { usePerpIsBuy } from "#/store/perps/tradePanel/perpIsBuy";

import { PerpWithCancel } from "./components/PerpWithCancel/PerpWithCancel";

export const PerpSummary: React.FC = () => {
  const { market } = useMarket();

  const { perpIsBuy, setPerpIsBuy } = usePerpIsBuy();

  const handleToggleBuySell = (id: string) => {
    const isBuy = id === "buy";
    setPerpIsBuy(isBuy);
  };

  return (
    <div className="mt-2 w-full">
      <BuySellSwitch isBuy={perpIsBuy} onChange={handleToggleBuySell} />

      <PerpWithCancel className="my-2" underlying={market.underlying} />
    </div>
  );
};
